export default "__VITE_ASSET__DznlKCJb__"